import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import * as React from 'react';
import classNames from "classnames";
import IntlMessage from '../../util/IntlMessage';
import {MenuMultiRenderShape} from './menuTypes';
import SingleNavLink from './SingleNavLink';

const MultiNavLink: React.FunctionComponent<MenuMultiRenderShape> =
    ({title, subMenus, icon: MenuIcon}: MenuMultiRenderShape) => {
        const [subMenuOpen, handleSubMenuOpen] = React.useState(false);

        return (
            <React.Fragment>
                <ListItem
                    button
                    component="li"
                    onClick={(): void => {
                        handleSubMenuOpen(!subMenuOpen);
                    }}
                    className={`list-item ${classNames({'item-active': subMenuOpen})}`}
                >
                    <ListItemIcon className="menu-icon">
                        {MenuIcon ? <MenuIcon /> : null}
                    </ListItemIcon>
                    <span className="menu text-capitalize">
                        <IntlMessage id={title} />
                    </span>
                </ListItem>
                <Collapse in={subMenuOpen} timeout="auto" className="sub-menu">
                    <React.Fragment>
                        <List className="list-unstyled py-0">
                            {subMenus && subMenus.map((subMenu) => (
                                <React.Fragment key={subMenu.title}>
                                    <SingleNavLink {...subMenu} />
                                </React.Fragment>
                            ))}
                        </List>
                    </React.Fragment>
                </Collapse>
            </React.Fragment>
        );
    };

export default MultiNavLink;
